import {LockIcon, RepoIcon} from '@primer/octicons-react'

import type {OrgRepositoryPickerRepository} from './org-repository-picker-types'

export function RepositoryDestinationVisual({
  repository,
  size = 16,
}: {
  repository: OrgRepositoryPickerRepository
  size?: number
}) {
  const Icon = repository.isPrivate ? LockIcon : RepoIcon
  return <Icon size={size} />
}

/** Announces a repository's visibility so the lock icon isn't the only cue for assistive tech. */
function repositoryAccessibleName(repository: OrgRepositoryPickerRepository): string {
  return `${repository.nameWithOwner}${repository.isPrivate ? ' (private)' : ''}`
}

export function destinationAccessibleName(repository: OrgRepositoryPickerRepository): string {
  return `Repository: ${repositoryAccessibleName(repository)}`
}

/** Action label for a control that changes the destination. */
export function changeDestinationLabel(repository: OrgRepositoryPickerRepository): string {
  return `Change destination, current repository: ${repositoryAccessibleName(repository)}`
}
